import { h } from 'preact';
import * as BaseComp from 'components/bolt/hub/hub.js';
import Store from 'store/store';

import { getDynamicData } from 'utils/bolt/dynamicData';
import slugify from 'utils/slugify';
import { arrayUnique } from 'utils/utils';
// import s from 'components/bolt/hub/hub.sss';

export default class Hub extends BaseComp.default {

	async loadCustomData(file) {
		const dynamicData = await getDynamicData(file);
		if (!dynamicData) {
			return;
		}

		this.heroCarousel = file !== 'production' && {
			hasGradient: true,
			content: dynamicData.hero?.map?.(slide => {
				if (!slide) {
					return;
				}
				return {
					id: slide.id,
					title: slide.title,
					description: slide.description,
					background: { desktop: slide.img, mobile: slide.mobileImg, alt: slide.alt },
					buttons: slide.buttons || []
				};
			}).filter(e => e)
		};
		this.carousels = dynamicData.carousels?.map?.(carousel => {
			if (!carousel?.content?.length) {
				return;
			}
			return {
				heading: carousel.name,
				anchor: slugify(carousel.name),
				tag: carousel.tag,
				tiles: carousel.content.map(srcTile => srcTile && {
					title: srcTile.title,
					teaser: srcTile.description,
					asset: srcTile.asset,
					altText: srcTile.altText,
					tag: srcTile.tag,
					path: /^https?:\/\//.test(srcTile.link) ? undefined : srcTile.link?.split('#')?.[0],
					buttons: srcTile.button && [
						{ btnCopy: srcTile.button, link: srcTile.link }
					]
				}).filter(e => e)
			};
		}).filter(e => e);
		this.forceUpdate();

		this.props.checkHash?.();
	}

	async componentDidMount(...args) {
		super.componentDidMount?.(...args);
		if (this.props.id === 'landingPage') {
			await this.loadCustomData('landing');
		} else if (this.props.id === 'library') {
			await this.loadCustomData('library');
		} else if (this.props.id === 'inProductionFilms') {
			await this.loadCustomData('production');
		}

		// Create appData entries to be able to link to film pages
		let pages = Store.get().appData.pages;
		let allLinkedPages = arrayUnique(
			(
				this.carousels?.flatMap(c => Object.values(c.tiles || []).map(e => Object.values(e?.buttons || [])[0]?.link)) || []
			).concat(
				Object.values(this.heroCarousel?.content || []).flatMap(slide => Object.values(slide.buttons || []).map(e => e?.link))
			).map(link => link?.split('#')[0]).filter(e => e && !/^https?:\/\//.test(e?.link))
		);
		allLinkedPages.forEach(slug => {
			if (!pages[slug]) {
				pages = pages.set(slug, {
					base: 'bolt',
					id: slug,
					data: {},
					page: 'filmPage',
					type: 'filmPage',
					path: '/film/' + slug + '/',
					customPageComponent: 'film'
				}).now();
			}
		});
	}

}
